/* @flow */

import * as React from 'react';
import {StarIcon} from 'shells/icon';

import './option-with-count.css';

export type ListOption = {
    value: string,
    label: string,
    favorite?: boolean,
    __isNew__?: boolean,
};

type Props = {
    label: string,
    favorite?: boolean,
};

/**
 * Option component for a GraphQL select object
 */
export function Option(props: Props) {
    return (
        <div styleName='option'>
            {props.favorite !== undefined ? (
                // If favorite is a prop and is true, it has opacity 1.
                // If favorite is a prop and is false, it has opacity 0.
                <div styleName='favorite-icon' style={{opacity: props.favorite ? 1 : 0}}>
                    <StarIcon />
                </div>
            ) : (
                undefined
            )}
            <div styleName='label'>{props.label}</div>
        </div>
    );
}
